import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import React from "react";
function URLWidget(props) {
  var BaseInput = props.registry.widgets.BaseInput;
  return React.createElement(BaseInput, _extends({
    type: "url"
  }, props));
}
if (process.env.NODE_ENV !== "production") {}
export default URLWidget;